<script lang="ts" setup>
import RouteStopStatusLabel from "@/views/trips/components/RouteStopStatus.vue";
import DeviationStatusLabel from "@/views/trips/components/DeviationStatusLabel.vue";
import type { TripMonitorRoute } from "@/api/trips/dto/trip-monitor";
import { FilterUtils } from "@/filters";
import OrderActionsTime from "@/components/order/OrderActionsTime.vue";
import StopTimer from "@/views/trips/components/StopTimer.vue";
import { RouteStatus } from "@/data/trip";
import { computed } from "vue";
import CompletedChip from "@/components/chips/CompletedChip.vue";

const filters = new FilterUtils();

const props = defineProps<{
  route: TripMonitorRoute;
}>();

const isCompleted = computed(() => {
  return props.route.status === RouteStatus.completed;
});
</script>

<template>
  <div>
    <completed-chip v-if="isCompleted" class="mb-2" prepared-icon="mdi-check" />
    <route-stop-status-label
      v-if="route.nextRouteStop?.status"
      :stop="route.nextRouteStop"
      class="mb-2"
    ></route-stop-status-label>

    <template v-if="route.nextRouteStop && route.nextRouteStop.checkInTime">
      <order-actions-time
        v-if="route.nextRouteStop"
        :check-in-time="route.nextRouteStop.checkInTime"
        :check-out-time="route.nextRouteStop.checkOutTime"
        :load-unload-time="route.nextRouteStop.loadUnloadTime"
        :stop-type="route.nextRouteStop.type"
        :time-to="null"
        :timezone="route.nextRouteStop.timezone"
        class="pl-2 font-size-11 text-grey-darken-2 mb-10px text-right"
      />

      <div class="d-flex align-center">
        <span class="font-weight-600 font-size-11 text-grey-darken-2 mr-2">Time at stop:</span>

        <stop-timer
          :end-time="route.nextRouteStop.checkOutTime"
          :icon-size="14"
          :start-time="route.nextRouteStop.checkInTime"
        ></stop-timer>
      </div>
    </template>

    <template v-else>
      <div class="d-flex align-center mb-1">
        <div class="font-size-12 text-grey-darken-2">Avg speed:</div>
        <div class="font-size-12 font-weight-500 text-grey-darken-3 ml-2">
          {{ filters.miles(route.lastCheckCall?.avgSpeed, 0) }} m/h
        </div>
      </div>
      <div class="d-flex align-center mb-1">
        <div class="font-size-12 text-grey-darken-2">Left:</div>
        <div class="font-size-12 font-weight-500 text-grey-darken-3 ml-2">
          {{ filters.miles(route.lastCheckCall?.nextStopDistance) }} miles
        </div>
      </div>
      <div class="d-flex align-center mt-1">
        <div class="font-size-12 text-grey-darken-2">Deviation:</div>
        <deviation-status-label
          v-if="route.lastCheckCall?.currentDeviationStatus"
          :deviation-status="route.lastCheckCall.currentDeviationStatus"
          class="ml-2"
        ></deviation-status-label>
      </div>
    </template>
  </div>
</template>
